module.exports = __webpack_public_path__ + "static/media/background1.68d2b658.png";